import {
  ENGLISH_IQ_DAILY_TARGET_MINUTES,
  type EnglishIqDailyTargetMinutesType,
} from '@repo/config';
import type { EnglishIqMessagesType } from '../../english-iq-messages-type';

interface IEnglishIqV2TargetPickerProps {
  messages: EnglishIqMessagesType['v2']['result'];
  onSelect: (minutes: EnglishIqDailyTargetMinutesType) => void;
  target: EnglishIqDailyTargetMinutesType;
}

export function EnglishIqV2TargetPicker({
  messages,
  onSelect,
  target,
}: IEnglishIqV2TargetPickerProps): React.JSX.Element {
  return (
    <section className="mt-10 rounded-3xl border border-[#f7edda]/12 bg-[#f7edda]/[0.035] p-5 sm:p-7">
      <fieldset>
        <legend className="text-2xl font-semibold tracking-tight">{messages.targetTitle}</legend>
        <p className="mt-2 text-sm leading-6 text-[#f7edda]/55">{messages.targetBody}</p>
        <div className="mt-5 flex flex-wrap gap-3">
          {ENGLISH_IQ_DAILY_TARGET_MINUTES.map((minutes) => (
            <label
              className={`inline-flex min-h-12 cursor-pointer items-center rounded-full px-6 font-bold transition motion-reduce:transition-none ${
                minutes === target
                  ? 'bg-[#ff7a1a] text-[#160c06]'
                  : 'border border-[#f7edda]/18 bg-black/20 text-[#fff8e9] hover:border-[#ff7a1a]'
              }`}
              key={minutes}
            >
              <input
                checked={minutes === target}
                className="sr-only"
                name="english-iq-daily-target"
                onChange={() => onSelect(minutes)}
                type="radio"
                value={minutes}
              />
              {messages.minutes.replace('{minutes}', String(minutes))}
            </label>
          ))}
        </div>
      </fieldset>
    </section>
  );
}
